export const LayoutMetaSymbol = Symbol("layout-meta");
export const PageRouteSymbol = Symbol("route");
